import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { selectMode } from "../app/appSlice";
import { Container, Row, Col } from "react-bootstrap";
import Title from "../components/Title";
import BackToTop from "../components/BackToTop";
import { updateTitle } from "../utils";
import { useGetUsersQuery } from "../app/apiSlice";

// Import gallery images
import bridgeImg from "../images/gallery-bridge.jpeg";
import citiesAfarImg from "../images/gallery-cities-afar.jpeg";
import citiesFountainImg from "../images/gallery-cities-fountain-1.jpeg";
import lakeWoodImg from "../images/gallery-lake-wood.jpeg";
import mountRainierImg from "../images/gallery-mount-rainier-together.jpeg";

const StyledSection = styled.section`
  padding: 4rem 0;
  min-height: calc(100vh - var(--nav-height) - 2rem);

  .gallery-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .gallery-col {
    display: flex;
  }

  .gallery-item {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    background: ${({ theme }) => (theme.name === "light" ? "#fff" : "#2b2b2b")};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    width: 100%;

    &:hover {
      transform: scale(1.02);
    }
  }

  .gallery-image {
    width: 100%;
    height: 300px;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }

  .image-description {
    padding: 0.75rem 1rem;
    color: ${({ theme }) => (theme.name === "light" ? "#333" : "#f5f5f5")};
    font-size: 0.95rem;
    line-height: 1.4;
    flex-grow: 1;
  }

  @media (max-width: 768px) {
    padding: 2rem 0;

    .gallery-image {
      height: 250px;
    }
  }
`;

const Gallery = () => {
  const theme = useSelector(selectMode);
  const { data: userData } = useGetUsersQuery();

  React.useEffect(() => {
    if (userData) {
      updateTitle(`${userData.name} | Gallery`);
    }
  }, [userData]);

  const galleryImages = [
    { 
      id: 1, 
      src: bridgeImg, 
      alt: "Bridge view",
      description: "Taken on Ohiopyle High Bridge, in Ohiopyle, Pennsylvania."
    },
    { 
      id: 2, 
      src: citiesAfarImg, 
      alt: "Cities from afar",
      description: "Cities Skylines: a city I built from scratch, this is the view of Apollotown taken afar, with the urban landscape at distance."
    },
    { 
      id: 3, 
      src: citiesFountainImg, 
      alt: "City fountain",
      description: "Cities Skylines: view from the city fountain in downtown Apollotown."
    },
    { 
      id: 4, 
      src: lakeWoodImg, 
      alt: "Lake and woods",
      description: "Taken at Catfish Pond, near Stone Mountain, in Atlanta, Georgia."
    },
    { 
      id: 5, 
      src: mountRainierImg, 
      alt: "Mount Rainier",
      description: "Me and my girlfriend, Avery, at Mount Rainier, Washington, you can see Mount Adams in the background."
    }
  ];

  return (
    <>
      <Container className="d-flex justify-content-center">
        <Title size="h2" text="Gallery" />
      </Container>
      <StyledSection>
        <Container className="gallery-container">
          <Row xs={1} md={2} lg={3} className="g-4">
            {galleryImages.map((image) => (
              <Col key={image.id} className="gallery-col">
                <div className="gallery-item">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="gallery-image"
                    loading="lazy"
                  />
                  <div className="image-description">
                    {image.description}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </StyledSection>
      <BackToTop />
    </>
  );
};

export default Gallery;
